import React from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { Button } from "../../../index";

export default function Form({ buttonText, className, submitFunction }) {
	const {
		register,
		handleSubmit,
		// watch,
		formState: { errors },
	} = useForm();

	// /* "handleSubmit" will validate your inputs before invoking
	const onSubmit = (data) => console.log(data);

	// console.log(watch("email"));
	// watch input value by passing the name of it

	return (
		<FormWrapper>
			<form onSubmit={handleSubmit(onSubmit)} className={className}>
				{/* errors will return when field validation fails  */}

				<div className="top-form">
					<div>
						<label>Full Name</label>
						<input
							type="text"
							{...register("fullName", { required: true })}
						/>
						{errors.email && <span>This field is required</span>}
					</div>

					<div>
						<label>Email</label>
						<input
							type="email"
							{...register("email", { required: true })}
						/>
						{errors.email && <span>This field is required</span>}
					</div>
				</div>

				<div className="input-container">
					<label>Subject</label>
					<input
						type="text"
						{...register("subject", { required: true })}
					/>
					{errors.email && <span>This field is required</span>}
				</div>

				<div className="input-container">
					<label>Message</label>
					<textarea
						type="text"
						{...register("message", { required: true })}
					/>
					{errors.email && <span>This field is required</span>}
				</div>

				<Button wide uppercase>
					{buttonText ? buttonText : "Submit"}
				</Button>
			</form>
		</FormWrapper>
	);
}

const FormWrapper = styled.div.attrs((props) => ({}))`
	.top-form {
		display: flex;
		margin-bottom: 2rem;

		> * {
			flex: 1;

			&:first-child {
				margin-right: 1rem;
			}
		}
	}

	.top-form,
	.input-container {
		margin-bottom: 30px;

		label {
			display: block;
			margin-bottom: 12px;
			font-size: 14px;
		}

		input,
		textarea {
			width: 100%;
			height: 3rem;
			margin-bottom: 0.6rem;

			border: none;
			border-radius: 4px;
			background: #f1f1f1;

			font-size: 0.8rem;
		}

		textarea {
			min-height: 8rem;
		}

		span {
			color: red;
			font-size: 0.8rem;
		}
	}

	@media (max-width: 768px) {
		.top-form {
			flex-direction: column;

			> * {
				&:first-child {
					margin-right: 0;
					margin-bottom: 2rem;
				}
			}
		}
	}
`;
